<template>
    <ul class="contaier">
        <li class="header-box">
            <van-image
                class="img-style"
                fit="cover"
                :src="tokenImage(option.image)"
            />
        </li>
        <li class="item-box ticket-box">
            <p class="inner-item title">
                <span class="left">{{option.name || '暂无名称'}}</span>
                <!-- <span class="ellipsis right"><i class="rmb">¥</i> 100</span> -->
            </p>

            <div class="inner-item time-box">
                <span class="inner-left">
                    <i class="iconhebei iconshizhong g-yellow-color"></i>
                    <span>时间:</span>
                </span>
                <span class="inner-right ellipsis">{{option._startTimeStr}} - {{option._endTimeStr}} </span>
            </div>

            <div class="inner-item ticket-box">
                <span class="inner-left">
                    <i class="iconhebei iconmenpiao- ticket-icon theme-color-font"></i>
                    <span>门票:</span>
                </span>
                <span v-if="option.price == 0 " class="inner-right ellipsis g-yellow-color">免费</span>
                <span v-else class="inner-right ellipsis g-yellow-color"><i class="rmb">¥</i> <i class="price">{{option.price}}</i> </span>
            </div>

            <div class="inner-item time-box" style="align-items: flex-start;">
                <span class="inner-left">
                    <i class="iconhebei iconshiliangzhinengduixiang violet-color"></i>
                    <span>地址:</span>
                </span>
                <span class="inner-right">{{option.address || '暂无地址'}}</span>
            </div>

            <!-- <div class="inner-item addres-box">
                <span class="inner-left">
                    <span class="adders">
                        <i class="iconhebei iconshiliangzhinengduixiang violet-color"></i>
                        <span>地址:</span>
                    </span>
                    <span class="adders-right">特展馆</span>
                </span>
                <span class="button-box theme-color-bg" v-touch:tap="bookingTickets">立即预约</span>
            </div> -->

        </li>

        <li class="row-item">
            <p class="title">
                <i class="iconhebei theme-color-font icondengpao"></i>
                <span class="tips-font">温馨提示</span>
            </p>
            <p class="desc-box qg-img-auto" v-if="option.message " v-html="option.message " > 
                {{option.message || '暂无温馨提示'}}
            </p>
            <p class="desc-box" v-else > 
                暂无温馨提示
            </p>
        </li>

        <li class="row-item">
            <p class="title">
                <i class="iconhebei theme-color-font iconxiangqing detail-icon"></i>
                <span class="tips-font">详情</span>
            </p>
            <p class="desc-box qg-img-auto desc-txt-box" v-if="option.content" v-html="option.content"> 
                {{option.content || '暂无详情'}}
            </p>
            <p class="desc-box" v-else> 
                暂无详情
            </p>
        </li>


        <li class="sign-up-box" v-if="(option.status === 1) && isShowBtn " >
            <div class="box-right theme-color-bg" v-touch:tap="bookingTickets" >
                立即预约
            </div>
        </li>

    </ul>
</template>

<script>
    import { 
        getExhibitionDetailUrl,
    } from '@ticketUrl';
    import util from '@util';
    import {
        tokenImage
    } from '@js/url.js';
    export default {
        data() {
            return {
                img: 'http://www.hebeimuseum.org.cn/upload/images/2014/6/619212265.jpg',
                option: {},
                isShowBtn: false,
                ticketId:'',
                exhibitionId:'',
            }
        },
        created() {
            this.inIt();
        },
        methods: {
            tokenImage,
            getDetail(){
                this.$http.get(getExhibitionDetailUrl, { params: { id: this.exhibitionId }  } )
                .then(res=>{
                    const {
                        data
                    } = res;
                    if(data){
                        data._startTimeStr = util.formatTime(new Date(data.startTime),'yyyy.MM.dd hh:mm');
                        data._endTimeStr = util.formatTime(new Date(data.endTime),'yyyy.MM.dd hh:mm');
                        // console.log(new Date().getTime() < data.applyEndTime)
                        // this.isShowBtn = new Date().getTime() < data.applyEndTime
                        this.isShowBtn = new Date().getTime() < data.appointEndTime
                        this.option = data;
                    }

                })
            },
            inIt(){
                const {
                    ticketId = '',
                    exhibitionId = ''
                } = this.$route.query;
                this.ticketId = ticketId;
                if(ticketId && exhibitionId){
                    this.exhibitionId = exhibitionId;
                }
                this.getDetail();
            },
            bookingTickets(){
                var tempObj = this.$store.state.tempTransmitParams || {};
                tempObj = Object.assign(
                    tempObj,
                    {
                        charge: this.option.isCharge === 0 ? 0 : 1,// 是否免费
                        ticketPrice: this.option.price,//  门票价格
                        name: this.option.name,// 门票名称
                    }
                )
                this.$router.push({name:'calendar', query: { ticketId: this.ticketId, eId: this.exhibitionId, type: 'exhibition' } })
            }
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/ticket-public.less";
    @import "./style/home-public-style.less";
    .contaier{
        @signUpHeight:52px;
        .desc-color{
            color: #7E7E7E;
        }
        .box-padding{
            padding: 24px 20px;
        }
        // padding-bottom: 0 !important;
        .header-box{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 186px;
            overflow: hidden;
            .img-style{
                float: left;
                height: 100%;
            }
        }
        .item-box{
            font-size: 14px;
            .box-padding();
            .unified-box-bottom();
            .white-box();
            .inner-item{
                margin-bottom: 12px;
                .flex-box();
                justify-content: flex-start;
                &:last-child{
                    margin-bottom: 0;
                }
                @boxWidth:80px;
                .inner-left{
                    width: @boxWidth;
                    color: #525252;
                    .flex-box();
                    justify-content: flex-start;
                    .iconhebei{
                        display: inline-block;
                        width: 30px;
                    }
                    .font-weight-500();
                    .ticket-icon{
                        &::before{
                            display: inline-block;
                            transform: translateY(-2PX);
                            font-size: 13px;
                        }
                    }
                }
                .inner-right{
                    width: ~'calc(100% - @{boxWidth})';
                    .desc-color();
                    .rmb{
                        font-size: 12px !important;
                    }
                    .price{
                        font-size: 20px;
                        .font-weight-500();
                    }
                }
            }
        }
        .ticket-box{
            .title{
                color: #525252;
                justify-content: space-between;
                .flex-box();
                align-items: baseline;
                font-size: 15px;
                margin-bottom: 24px;
                .left{
                    .font-weight-600();
                    // max-width: 80%;
                }
                .right{
                    font-size: 20px;
                    max-width: 20%;
                    color: #FFAE08;
                    .font-weight-500();
                    .rmb{
                        font-size: 10px !important;
                    }
                }
            }
        }
        .addres-box{
            position: relative;
            .flex-box();
            .inner-left{
                .flex-box();
                // width: 100%;
                width: ~'calc(100% - 90px)' !important;
                .iconhebei{
                    display: inline-block;
                    width: 30px;
                }
                .adders{
                    width: 80px;
                    .flex-box();
                    justify-content: flex-start;
                }
                .adders-right{
                    font-weight: normal;
                    .desc-color();
                }
            }
            .button-box{
                width:90px;
                height:30px;
                border-radius:8px;
                color: white;
                .flex-box();
                justify-content: center;
            }
            justify-content: space-between !important;
        }
        .row-item{
            .box-padding();
            .white-box();
            .unified-box-bottom();
            .title{
                // border: 1px solid red;
                color: #525252;
                height: 25px;
                .flex-box();
                justify-content: flex-start;
                .tips-font{
                    font-size: 14px;
                    .font-weight-500();
                }
                .iconhebei{
                    box-sizing: border-box;
                    width: 22px;
                    &::before{
                        display: inline-block;
                        font-size: 25px;
                        // transform: translateY(-2px);
                    }
                    margin-right: 10px;
                }
                .detail-icon{
                    margin-left: 3px;
                    &::before{
                        font-size: 16px;
                    }
                }
            }
            .desc-box{
                margin-top: 10px;
                font-size:14px;
                .font-weight-400();
                color:rgba(126,126,126,1);
                line-height:20px;
            }
            .desc-txt-box{
                & /deep/ img{
                    width: 100% !important;    
                    height: auto !important;                
                    display: block;
                }
            }
        }

        .sign-up-box{
            .white-box();
            border-top: .1px solid #CCCCCC;
            position: fixed;
            bottom: 0;
            width: 100%;
            height: @signUpHeight;
            line-height: @signUpHeight;
            align-items: center;
            .flex-box();
            .font-weight-500();
            .box-right{
                font-size: 16px;
                color: white;
                width: 100%;
                .flex-box();
                justify-content: center ; 
            }
            .box-left{
                font-size: 14px;
                width: 70%;
                color: #525252;
                .box-padding();
                box-sizing: border-box;
                padding-bottom: 0;
                padding-top: 0;
                .number{
                    font-size: 20px;
                    padding-left: 10px;
                }
                .rmb{
                    font-size: 12px !important;
                }
                .icon-size{
                    // .red();
                    .font-weight-500();
                    margin-right: 5px;
                    &::before{
                        display: inline-block;
                        .font-weight-500();
                        font-size: 12px !important;
                    }
                }
            }
        }
        padding-bottom: @signUpHeight;
    }
</style>